/**
 * The address a link to somewhere outside the ERP may point at, or `null` to
 * show the text without a link.
 *
 * A tracking URL is stored verbatim from the channel, and a channel is not
 * trusted input: `javascript:` and `data:` hrefs would run script, or render
 * someone else's page, for whoever clicked. Only `http` and `https` get
 * through. A relative address is refused too, because it would resolve
 * against the ERP's own origin and open the ERP, not a courier.
 *
 * The parsed `href` is returned rather than the string that came in, so what
 * is rendered is exactly what was checked.
 *
 * `modules/docs/markdown.ts` has a `safeHref` of its own with a different
 * policy — it lets `mailto:` and in-app paths through, which is right for a
 * document and wrong for a courier link — so the two are not shared.
 */
export function safeWebHref(value: string | null | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value.trim());
    return url.protocol === "http:" || url.protocol === "https:"
      ? url.href
      : null;
  } catch {
    return null;
  }
}
